import ListIcon from '@mui/icons-material/List';
import CardAction from '../../../../card/CardAction';
import './ViewLessonDetailAction.scss';

const defaultProps = {
  onClick: () => {},
  className: '',
};

/**
 * Unlock Lesson Action Container
 */
export default function ViewLessonDetailAction(p) {
  const {
    onClick,
    className,
  } = { ...defaultProps, ...(p || {}) };
  return (
    <CardAction
      icon={<ListIcon aria-hidden='false' />}
      actionHandler={onClick}
      className={`view-lesson-detail-action ${className}`}
      data-test='lesson-detail-action'
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
